module.exports = __webpack_public_path__ + "static/media/right-arrow.45c8b024.svg";